/* src/app/front-layout/consortiums/grammar-schools/grammar-schools.component.css */
.cs-head {
  margin-top: 100px;
  width: 100%;
  height: 150px;
  background-image: url(/assets/images/cs_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cs-head h1 {
  font-size: 55px;
  font-weight: 600;
  color: #0077b6;
}
.ks {
  font-size: 24px;
  font-weight: 800;
  text-align: center;
  cursor: pointer;
  background:
    linear-gradient(
      270deg,
      #ff0057,
      #ff7c00,
      #8f00ff,
      #ff0057);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shine 5s linear infinite;
}
@keyframes shine {
  0% {
    background-position: 0% center;
  }
  100% {
    background-position: 200% center;
  }
}
.school-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
}
.school-card {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  padding: 10px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.visit-btn {
  width: 100px;
  background-color: #0077b6;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}
.visit-btn:hover {
  background-color: #577eec;
}
@media (max-width: 768px) {
  .cs-head {
    margin-top: 80px;
    height: 120px;
  }
  .cs-head h1 {
    font-size: 32px;
    text-align: center;
    padding: 0 15px;
  }
  .school-list {
    margin: 10px;
  }
  .school-card {
    width: 95%;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 15px;
    font-size: 16px;
  }
  .visit-btn {
    width: 100%;
    margin-top: 10px;
    padding: 10px 15px;
    font-size: 14px;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .cs-head {
    height: 100px;
  }
  .cs-head h1 {
    font-size: 28px;
  }
  .school-card {
    font-size: 15px;
    padding: 8px 12px;
  }
  .visit-btn {
    font-size: 13px;
    padding: 8px 12px;
  }
}
/*# sourceMappingURL=grammar-schools.component.css.map */
